import { GetServerSidePropsContext } from 'next';

import { Locale } from '@silvertours/back-domain-sitegroup';
import { NewsletterPageServerSideRequest } from '@silvertours/back-runtime-landingpages';
import { LandingPageLegacy } from '@silvertours/front-pages';

export const getServerSideProps = (nextContext: GetServerSidePropsContext) => {
  const handler = new NewsletterPageServerSideRequest(Locale.French.value);

  return handler.getServerSideProps(nextContext);
};

export default LandingPageLegacy.NewsletterPage;
